import React, { Component } from 'react';
import './App.css';
import resume from './resume.json';
import Experience from './Experience';
import Project from './Project';
import Skill from './Skill';
import Education from './Education';
import Certification from './Certification';
import Language from './Language';

class App extends Component{

  renderExperience() {
    let resultsArray = [];
    resume.experiences.map((item, i) => {
      resultsArray.push(<Experience item={item} key={i} />);
      });
   return resultsArray;
  }
  renderProjects() {
     let resultsArray = [];
    resume.projects.map((item, i) => {
      resultsArray.push(<Project item={item} key={i} />);
      });
   return resultsArray;
  }
   renderSkills() {
     let resultsArray = [];
    resume.skills.map((item, i) => {
      resultsArray.push(<Skill item={item} key={i} />);
      });
   return resultsArray;
  }
  renderEducations() {
     let resultsArray = [];
    resume.education.map((item, i) => {
      resultsArray.push(<Education item={item} key={i} />);
      });
   return resultsArray;
  }
  renderCertifications() {
     let resultsArray = [];
    resume.certification.map((item, i) => {
      resultsArray.push(<Certification item={item} key={i} />);
      });
   return resultsArray;
  }
  renderLanguages() {
     let resultsArray = [];
    resume.languages.map((item, i) => {
      resultsArray.push(<Language item={item} key={i} />);
      });
   return resultsArray;
  }
  renderInterests() {
    let resultsArray = [];
    resume.interests.map((item, i) => {
        resultsArray.push(<li key={i}>{item}</li>);
    });
    return resultsArray;
  }

  render() {
  return (
   
        <div className="wrapper">
        
         <nav className="navbar navbar-expand-lg bg-light">
             <div className="container-fluid">
               <a href="https://www.francescomalagrino.com/"><i className="fas fa-home"></i> Home</a>
            </div>
        </nav>
        <div className="sidebar-wrapper">
            <div className="profile-container">
                <img className="profile" src={resume.image} alt="Profile picture" />
                <h1 className="name">{resume.name}</h1>
                <h3 className="tagline">Software Architect</h3>
            </div>
            
            <div className="contact-container container-block">
                <ul className="list-unstyled contact-list">
                    <li className="email"><i className="fas fa-envelope"></i><a href="mailto: fracesco.malagrino@gmail.com" rel="noreferrer">{resume.email}</a></li>
                    <li className="phone"><i className="fas fa-phone"></i><a href="tel:+353899417100" rel="noreferrer">{resume.phone}</a></li>
                    <li className="website"><i className="fas fa-globe"></i><a href={resume.website} rel="noreferrer" target="_blank">{resume.website}</a></li>
                    <li className="linkedin"><i className="fab fa-linkedin-in"></i><a href={resume.linkedin} target="_blank" rel="noreferrer">My Linkedin</a></li>
                    <li className="github"><i className="fab fa-github"></i><a href={resume.github} target="_blank" rel="noreferrer">{resume.github}</a></li>
                </ul>
            </div>
            <div className="education-container container-block">
                <h2 className="container-block-title">Education</h2>
                 {this.renderEducations()}    
            </div>

            <div className="education-container container-block">
                <h2 className="container-block-title">Certification</h2>
                 {this.renderCertifications()}    
            </div>
            
            <div className="languages-container container-block">
                <h2 className="container-block-title">Languages</h2>
                <ul className="list-unstyled interests-list">
                   {this.renderLanguages()}    
                </ul>
            </div>
            
            <div className="interests-container container-block">
                <h2 className="container-block-title">Interests</h2>
                <ul className="list-unstyled interests-list">
                    {this.renderInterests()}
                </ul>
            </div>
            
        </div>
        
        <div className="main-wrapper">
            
            <section className="section summary-section">
                <h2 className="section-title"><span className="icon-holder"><i className="fas fa-user"></i></span>Career Profile</h2>
                <div className="summary">
                    <p>I am an enthusiastic and reliable Java Software Architect with over ten years of experience in Java technologies and I have kowledge in CMS,E-commerce,Payment,Portal and Social Network<br />
                    below all my experience and projects</p>
                </div>
            </section>
            
            <section className="section experiences-section">
                <h2 className="section-title"><span className="icon-holder"><i className="fas fa-briefcase"></i></span>Experiences</h2>
                
               {this.renderExperience()}
              
                
            </section>
            
            <section className="section projects-section">
                <h2 className="section-title"><span className="icon-holder"><i className="fas fa-archive"></i></span>Projects</h2>
                <div className="intro">
                    <p>Here a list of all my project</p>
                </div>

                 {this.renderProjects()}
                
                
            </section>
            
            <section className="skills-section section">
                <h2 className="section-title"><span className="icon-holder"><i className="fas fa-rocket"></i></span>Skills &amp; Proficiency</h2>
                <div className="skillset">        
                   {this.renderSkills()}
                    
                </div>  
            </section>
            
        </div>
    </div>
  );
}
}

export default App;
